import { LockSimple } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

export const PrivateProfileNotice = ({ onClose }) => (
  <div className="p-10 text-center" data-testid="private-profile-notice">
    <div className="mx-auto mb-4 w-14 h-14 bg-[#FAFAFA] border border-[#E4E4E7] flex items-center justify-center">
      <LockSimple size={26} weight="fill" className="text-[#0047FF]" />
    </div>
    <h2 className="font-heading text-xl font-bold text-[#09090B]">This profile is private</h2>
    <p className="mt-2 text-sm text-[#71717A]">Only this player and their saved friends can see their profile and stats.</p>
    <Button variant="outline" onClick={onClose} className="mt-6 border-[#E4E4E7]" data-testid="private-profile-close">Close</Button>
  </div>
);
